$(function() {
  let nav = $('.dealer-nav a');
  let content = $('.dealer-region-content');
  nav.on('click', function(e) {
    if (!$(this).hasClass('active')) {
      let id = $(this).attr('href');
      nav.removeClass('active');
      content.removeClass('active');
      $(this).addClass('active');
      $('.dealer-region-content' + id).addClass('active');
      e.preventDefault();
    }
  });
});



$(function() {
  $('.dealer-region ul').css('display','none')
  $('.dealer-region summary').on('click',function(e){
    e.preventDefault();
    if(!$(this).parents('.dealer-region').prop('open')){
      $(this).closest('details').attr('open', true);
      $(this).next().slideDown(500, function(e) {
        $(this).next().stop(false, true);
      });
    }
    else{
      $(this).next().slideUp(500, function(e) {
        $(this).next().stop(false, true);
      });
      setTimeout(() => {
        $(this).closest('details').attr('open', false);
      }, 500);
    }
    // if($(this).parens('.dealer-region').attr('open')){
    // }
  });
});
